import { ComponentProps, forwardRef } from "react";
import { Icon } from "./Icon";
import { css } from "@emotion/react";

type IconBoxProps = Omit<ComponentProps<typeof Icon>, "fallback"> & {
  name: IconName;
  size?: "xl" | "large" | "medium" | "small" | "extraSmall";
  color?: string;
  noIconSize?: boolean;
};

export const IconBox = forwardRef<HTMLElement, IconBoxProps>(
  ({ size = "large", color, noIconSize = false, ...props }, ref) => {
    const pixel = {
      xl: 32,
      large: 28,
      medium: 24,
      small: 20,
      extraSmall: 16,
    }[size];

    return (
      <Icon
        {...props}
        name={props.name}
        ref={ref}
        css={css`
          ${noIconSize ? "" : `width: ${pixel}px; height: ${pixel}px;`}
          ${color ? `color: ${color};` : ""}
          display: flex;
          align-items: center;
          justify-content: center;
        `}
        fallback={
          <div
            className={props.className}
            css={css`
              width: ${pixel}px;
              height: ${pixel}px;
              ${color ? `color: ${color};` : ""}
            `}
          />
        }
      />
    );
  },
);

IconBox.displayName = "IconBox";